export default "__VITE_ASSET__b33689c7__"